import styled from 'styled-components'

export const TextInput = styled.div`
  font-size: 11px;
`